import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, node, func, bool, shape } from 'prop-types';
import Flex from '../../atoms/Flex';
import { Container, Input } from './attribute-radio.styles';

const AttributeRadio = _ref => {
  let {
    checked,
    disabled,
    type,
    value,
    children,
    onChange,
    style,
    path,
    onVariationClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["checked", "disabled", "type", "value", "children", "onChange", "style", "path", "onVariationClick"]);

  return /*#__PURE__*/React.createElement(Container, {
    type: type,
    onClick: e => onVariationClick ? onVariationClick(e, {
      value,
      type,
      path
    }) : null
  }, /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    "data-testid": "attribute-input",
    type: "radio",
    name: type,
    value: value,
    id: `${type}-${value}`,
    checked: checked,
    disabled: disabled,
    onChange: e => onChange(e, {
      value,
      type
    }),
    height: (style == null ? void 0 : style.height) || '70px',
    width: (style == null ? void 0 : style.width) || '70px'
  })), /*#__PURE__*/React.createElement(Flex, {
    as: "label",
    "data-testid": "attribute-item",
    borderWidth: 1,
    borderColor: "whisper",
    borderStyle: "solid",
    borderRadius: "default",
    padding: 2,
    color: "text.base",
    fontSize: 2,
    fontWeight: "medium",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    htmlFor: `${type}-${value}`
  }, children));
};

process.env.NODE_ENV !== "production" ? AttributeRadio.propTypes = {
  style: shape({}),
  checked: bool,
  disabled: bool,
  type: string,
  value: string,
  children: node,
  onChange: func,
  path: string,
  onVariationClick: func
} : void 0;
export default AttributeRadio;